import React from 'react';
import { Info, AlertTriangle } from 'lucide-react';
import { cn } from '@/lib/utils';

interface StageAnnotationProps {
  variant: 'info' | 'warn';
  children: React.ReactNode;
  className?: string;
}

export function StageAnnotation({ variant, children, className }: StageAnnotationProps) {
  const isWarn = variant === 'warn';
  return (
    <div
      className={cn(
        'flex items-start gap-2 px-3 py-2 rounded-lg text-xs border ml-52',
        isWarn
          ? 'bg-amber-50 border-amber-200 text-amber-800 dark:bg-amber-900/20 dark:border-amber-700 dark:text-amber-300'
          : 'bg-blue-50 border-blue-200 text-blue-800 dark:bg-blue-900/20 dark:border-blue-700 dark:text-blue-300',
        className,
      )}
    >
      {isWarn
        ? <AlertTriangle className="h-3.5 w-3.5 shrink-0 mt-px" />
        : <Info className="h-3.5 w-3.5 shrink-0 mt-px" />}
      <span>{children}</span>
    </div>
  );
}
